
import * as React from 'react';
import { connect } from 'react-redux';
import { Dropdown, Button } from 'semantic-ui-react';
import { IRootState } from 'store/modules';
import { ROUTES } from 'config/routes';
import * as App from 'application';

export interface IUserMenuProps {
	isLoggedIn: boolean;
	hasSubscription: boolean;
	displayName?: string;
	isBacker?: boolean;
	onAccountSettings();
	onLogout();
	onSignUp(buttonText);
	onLogin(buttonText);
}

const mapStateToProps = (state: IRootState) => ({
	displayName: App.User.displayName(state),
	isLoggedIn: App.Authentication.isAuthenticated(state),
	hasSubscription: App.User.hasSubscriptions(state)
});

const mapDispatchToProps = (dispatch) => ({
	onLogin: (cbaButtonText) => App.Authentication.openLogin(dispatch, cbaButtonText),
	onSignUp: (cbaButtonText) => App.Authentication.openSignUp(dispatch, cbaButtonText),
	onLogout: () => App.Authentication.logout(dispatch),
	onAccountSettings: () => App.Navigation.redirectTo(dispatch, ROUTES.SETTINGS)
});

const UserMenuComponent: React.SFC<IUserMenuProps> = (props) => {
	let signUp = <Button onClick={() => props.onSignUp('Sign Up')} size="small"  >Sign Up</Button>
	let control = <Dropdown text="Log In" onClick={() => props.onLogin('Log In')} icon='' />;
	if (props.isLoggedIn) {
		signUp = null;
		const linkToSettings = props.hasSubscription ? <Dropdown.Item text='Account' onClick={props.onAccountSettings} /> : null;
		control = (<Dropdown text={props.displayName}>
			<Dropdown.Menu>
				{linkToSettings}
				{/* <Dropdown.Item text='Get User Info' onClick={props.refreshUserInfo} /> */}
				<Dropdown.Item text='Logout' onClick={props.onLogout} />
			</Dropdown.Menu>
		</Dropdown>);
	}
	return <div> {control} {signUp} </div>;
}

export const UserMenu = connect(
	mapStateToProps,
	mapDispatchToProps,
)(UserMenuComponent);


// WEBPACK FOOTER //
// ./src/components/presentational/application/UserMenu.tsx